import { render } from "./sel-pagination.vue?vue&type=template&id=256783f5&scoped=true"
import script from "./sel-pagination.vue?vue&type=script&lang=js"
export * from "./sel-pagination.vue?vue&type=script&lang=js"

import "./sel-pagination.vue?vue&type=style&index=0&id=256783f5&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256783f5"]])

export default __exports__